'use client';

import { Box, Container } from '@mui/material';
import FaqAccordionList from './components/FaqAccordionList';
import FaqHelpSection from './components/FaqHelpSection';
import FaqHero from './components/FaqHero';
import { useFaqs } from '@/api/hooks/useFaqs';
interface FaqContainerProps {
  hideBlueBox?: boolean;
}
export default function FaqContainer({
  hideBlueBox = false
}: FaqContainerProps): JSX.Element {
  const {
    data
  } = useFaqs('site');
  return <Box sx={{
    width: '100%',
    bgcolor: 'background.bg'
  }} data-sentry-element="Box" data-sentry-component="FaqContainer" data-sentry-source-file="FaqContainer.tsx">
      {!hideBlueBox && <FaqHero />}

      <Container maxWidth='lg' sx={{
      py: {
        xs: 'var(--spacing_xl)',
        md: 'var(--spacing_xxxl)'
      },
      pb: {
        xs: 'var(--spacing_xxxl)',
        md: 'var(--spacing_xxxl)'
      }
    }} data-sentry-element="Container" data-sentry-source-file="FaqContainer.tsx">
        <FaqAccordionList data={data} data-sentry-element="FaqAccordionList" data-sentry-source-file="FaqContainer.tsx" />
        {!hideBlueBox && <FaqHelpSection />}
      </Container>
    </Box>;
}